import axios from 'axios';
import { requestPermission, getFCMToken, onForegroundMessage } from '../firebase';
import { API_URL } from '../config/api';

/* ── Initialize push notifications after login ── */
export const initNotifications = async (stage) => {
  try {
    const granted = await requestPermission();
    if (!granted) {
      console.warn('[FCM] initNotifications: permission denied by user');
      return { success: false, reason: 'permission_denied' };
    }

    const token = await getFCMToken();
    if (!token) {
      console.warn('[FCM] initNotifications: could not obtain FCM token');
      return { success: false, reason: 'token_failed' };
    }

    await axios.post(`${API_URL}/notifications/token`, { fcmToken: token, stage });
    console.log('[FCM] Notifications initialized — stage:', stage);
    return { success: true, token };
  } catch (err) {
    console.error('[FCM] initNotifications error:', err.message);
    return { success: false, reason: 'server_error' };
  }
};

/* ── Called when journey stage changes ── */
export const updateNotificationStage = async (stage) => {
  try {
    await axios.patch(`${API_URL}/notifications/stage`, { stage });
    console.log('[FCM] Topic subscriptions updated — stage:', stage);
  } catch (err) {
    console.warn('[FCM] updateNotificationStage failed (non-critical):', err.message);
  }
};

/* ── Listen for foreground (in-app) notifications ── */
export const listenForegroundNotifications = (onNotification) =>
  onForegroundMessage((payload) => {
    const { title, body } = payload.notification || {};
    console.log('[FCM] Foreground message received:', title);
    if (title && onNotification) onNotification({ title, body, data: payload.data });
  });
